import { AlertOctagon, Flame, HelpCircle, Heart, MessageCircle, Sparkles } from "lucide-react";
import { COMMENT_QUICK_VIEWS, type CommentQuickViewId } from "@/lib/commentLabels";
import { cn } from "@/lib/utils";

const ICONS: Record<CommentQuickViewId, typeof Flame> = {
  all: MessageCircle,
  action: Flame,
  historia: Sparkles,
  cta: Heart,
  pytanie: HelpCircle,
  atak: AlertOctagon,
};

type Props = {
  activeId: CommentQuickViewId;
  counts: Partial<Record<CommentQuickViewId, number>>;
  onSelect: (id: CommentQuickViewId) => void;
};

export default function CommentsQuickViews({ activeId, counts, onSelect }: Props) {
  return (
    <div className="mb-6 grid gap-3 sm:grid-cols-2 xl:grid-cols-6">
      {COMMENT_QUICK_VIEWS.map((view) => {
        const Icon = ICONS[view.id];
        const active = activeId === view.id;
        const count = counts[view.id];
        return (
          <button
            key={view.id}
            type="button"
            onClick={() => onSelect(view.id)}
            className={cn(
              "rounded-xl border p-4 text-left transition-all",
              active
                ? "border-brand bg-white shadow-md ring-2 ring-brand/30"
                : "border-slate-200 bg-white shadow-sm hover:border-slate-300 hover:shadow",
            )}
          >
            <div className="flex items-start gap-3">
              <div
                className={cn(
                  "flex h-9 w-9 shrink-0 items-center justify-center rounded-lg",
                  active ? "bg-brand/15 text-brand" : "bg-slate-100 text-slate-600",
                )}
              >
                <Icon className="h-4 w-4" />
              </div>
              <div className="min-w-0">
                <div className="flex items-baseline gap-2">
                  <span className="text-sm font-semibold text-slate-900">{view.label}</span>
                  {count != null && (
                    <span className="text-xs font-medium text-slate-500">{count}</span>
                  )}
                </div>
                <p className="mt-0.5 text-xs leading-snug text-slate-500">{view.description}</p>
              </div>
            </div>
          </button>
        );
      })}
    </div>
  );
}
